import T from 'prop-types'
import React from 'react'

class LoadingValue extends React.Component {
  static displayName = 'LoadingValue'

  static propTypes = {
    light: T.bool,
    ellipsisClasses: T.string
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    //return <span className="message loading"><svg className="loading_circle_mini"><circle r="4" cx="50%" cy="50%"></circle></svg></span>

    return (
      <span
        className={`loading_ellipsis ${this.props.light ? 'light' : ''} ${this
          .props.ellipsisClasses || ''}`}
      >
        <span>&bull;</span>
        <span>&bull;</span>
        <span>&bull;</span>
      </span>
    )
  }
}

export default LoadingValue
